import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

export class Tag<E> {
  public inicio: number;
  public fim: number;
  public cor: string;
  public data: E;
}

export class EditorTextoOnChangeEvent {
  antigo: string;
  novo: string;
  inicioAlteracao: number;
  diferenca: number;
}

export class TextoSelecao {
  constructor(public inicio?: number, public fim?: number) {}

  public isSelecionado() {
    return this.inicio !== undefined;
  }
}

@Component({
  selector: 'app-editor-texto',
  templateUrl: './editor-texto.component.html',
  styleUrls: ['./editor-texto.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EditorTextoComponent implements OnInit {
  @ViewChild('elTextarea', { static: true })
  public elTextarea: ElementRef;

  @ViewChild('elHighlights', { static: true })
  public hltHighlights: ElementRef;

  @ViewChild('elBackdrop', { static: true })
  public elBackdrop: ElementRef;

  @ViewChild('elContainer', { static: true })
  public elContainer: ElementRef;

  @Input()
  public texto: string;

  @Input()
  public readonly: false;

  @Output()
  public textoChange = new EventEmitter();

  @Input()
  private tags: Tag<any>[] = [];

  @Output()
  public onSelection: EventEmitter<TextoSelecao> = new EventEmitter<TextoSelecao>();

  @Output()
  public onChange: EventEmitter<EditorTextoOnChangeEvent> = new EventEmitter<EditorTextoOnChangeEvent>();

  ngOnInit(): void {}

  public atualizar(): void {
    let textoEstilizado = '';

    for (let i = 0; i < this.texto.length; i++) {
      const tagsInicio = this.getTagsPorInicio(i);
      const tagsFim = this.getTagsPorFim(i + 1);

      if (tagsInicio.length > 0) {
        tagsInicio.forEach((tag) => {
          textoEstilizado += `<span class="hlt-tag" style="background-color: ${tag.cor}">`;
        });
      }

      textoEstilizado += this.texto[i];

      if (tagsFim.length > 0) {
        tagsFim.forEach(() => {
          textoEstilizado += '</span>';
        });
      }
    }

    this.hltHighlights.nativeElement.innerHTML = textoEstilizado;
  }

  public getTagsPorInicio(inicio: number): Tag<any>[] {
    return this.tags.filter((tag) => tag.inicio === inicio);
  }

  public getTagsPorFim(fim: number): Tag<any>[] {
    return this.tags.filter((tag) => tag.fim === fim);
  }

  public getTagsQuePossuemInicioOuFimAposIndice(indice: number): Tag<any>[] {
    return this.tags.filter((tag) => tag.inicio > indice || tag.fim > indice);
  }

  public sincronizar(): void {
    const height = this.elContainer.nativeElement.clientHeight;

    this.elTextarea.nativeElement.style.height = height + 'px';
    this.elBackdrop.nativeElement.style.height = height + 'px';

    this.atualizar();
  }

  public limparSelecao(): void {
    if (window.getSelection().empty) {
      // Chrome
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      window.getSelection().removeAllRanges();
    }
  }

  public onSelectionAction(ev: any): void {
    const textoSelecao = new TextoSelecao(ev.target.selectionStart, ev.target.selectionEnd);

    this.onSelection.emit(textoSelecao);
  }

  public onChangeAction(textoNovo: string): void {
    const textoAntigo = this.texto;
    this.texto = textoNovo;

    const diferenca = textoNovo.length - textoAntigo.length;
    const textoMaior = diferenca > 0 ? textoNovo.length : textoAntigo.length;

    let inicioAlteracao = -1;

    // Verifica onde comecou a alteracao
    for (let i = 0; i < textoMaior; i++) {
      const ca = textoAntigo[i];
      const cn = textoNovo[i];

      if (ca !== cn) {
        inicioAlteracao = i;
        break;
      }
    }
    this.textoChange.emit(textoNovo);
    this.onChange.emit({
      antigo: textoAntigo,
      novo: textoNovo,
      inicioAlteracao,
      diferenca,
    });

    this.atualizar();
  }

  public onScrollAction(): void {
    const scrollTop = this.elTextarea.nativeElement.scrollTop;
    this.elBackdrop.nativeElement.scrollTop = scrollTop;
  }
}
